import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=07256612&scoped=true&"
import script from "./CardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=07256612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07256612",
  null
  
)

export default component.exports